import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import { CardHeader, FormHelperText, OutlinedInput, Typography } from '@material-ui/core';

const InfoCollection = ({ control, errors, dataCollection, setValue, isMobile }) => {
    const { t } = useTranslation();

    useEffect(() => {
        setValue('name', dataCollection.name || '');
        setValue('description', dataCollection.description || '');
    }, [dataCollection, setValue]);

    const cardStyle = isMobile
        ? {
              marginTop: 8,
              marginBottom: 16,
              borderRadius: 12,
              border: '1px solid #E8E8E8',
              boxShadow: '0px 1px 3px rgba(0,0,0,0.06)',
          }
        : {};

    return (
        <Card elevation={isMobile ? 0 : 0} style={cardStyle}>
            {!isMobile && (
                <CardHeader titleTypographyProps={{ variant: 'h6' }} title={t('Collection.addTitle')} />
            )}
            <CardContent style={isMobile ? { padding: 16 } : undefined}>
                {isMobile && (
                    <Typography
                        variant="subtitle1"
                        style={{ fontWeight: 600, fontSize: 16, marginBottom: 12, color: '#1E1E1E' }}
                    >
                        {t('Collection.addTitle')}
                    </Typography>
                )}

                <Grid container spacing={isMobile ? 2 : 3}>
                    <Grid item xs={12}>
                        <FormControl>
                            <FormLabel error={errors?.name ? true : false}>{t('Collection.nameCollection')}*</FormLabel>
                            <Controller
                                render={({ field }) => (
                                    <OutlinedInput
                                        {...field}
                                        fullWidth
                                        disabled={dataCollection ? dataCollection.default ? true : false : false}
                                        error={errors.name ? true : false}
                                        margin="normal"
                                    />
                                )}
                                control={control}
                                rules={{ required: true }}
                                name="name"
                            />
                            <FormHelperText error={errors?.name ? true : false}>{errors?.name ? t('Product.errors?.name') : ''}</FormHelperText>

                        </FormControl>
                    </Grid>

                    {/*<Grid item xs={12}>
                        <FormControl>
                            <FormLabel>{t('Collection.descriptionCollection')}</FormLabel>
                            <Controller
                                variant="outlined"
                                render = {({ field})=> (
                                <TextField/>
                            )}
                                fullWidth
                                control={control}
                                defaultValue=""
                                margin="normal"
                                name="description"
                                rows={5}
                                rowsMax={4}
                            />
                        </FormControl>
    </Grid>*/}
                </Grid>

            </CardContent>
        </Card>
    );
};



export default connect()(InfoCollection);